export class RecruiterMcpManager {
    constructor(api) {
        this.api = api;
        this.snapshot = null;
        this.listeners = new Set();
        this.session = 0;
        this.getSnapshot = () => this.snapshot;
        this.subscribe = (listener) => {
            this.listeners.add(listener);
            return () => { this.listeners.delete(listener); };
        };
    }
    clear() {
        this.session++;
        this.snapshot = null;
        this.emit();
    }
    emit() {
        for (const listener of this.listeners)
            listener();
    }
    async load() {
        const session = this.session;
        const snapshot = await this.api().getRecruiterMcpStatus();
        if (session !== this.session)
            return;
        this.snapshot = snapshot;
        this.emit();
    }
    setMode(mode) {
        if (this.snapshot)
            this.snapshot = { ...this.snapshot, mode };
        this.emit();
    }
    async connect(input) {
        const session = this.session;
        const { grant } = await this.api().connectRecruiterMcp(input);
        if (session !== this.session)
            return;
        if (this.snapshot)
            this.snapshot = { ...this.snapshot, grants: [...this.snapshot.grants.filter(item => item.id !== grant.id), grant] };
        this.emit();
    }
    async revoke(grantId) {
        const session = this.session;
        const { grant } = await this.api().revokeRecruiterMcp(grantId);
        if (session !== this.session)
            return;
        if (this.snapshot)
            this.snapshot = { ...this.snapshot, grants: this.snapshot.grants.map(item => item.id === grant.id ? grant : item) };
        this.emit();
    }
    async approve(input) {
        const session = this.session;
        const { operation } = await this.api().approveRecruiterMcp(input);
        if (session !== this.session)
            return;
        if (this.snapshot)
            this.snapshot = { ...this.snapshot, operations: this.snapshot.operations.map(item => item.id === operation.id ? operation : item) };
        this.emit();
    }
    async createRun(input) {
        const session = this.session;
        const { run } = await this.api().createRecruiterMcpRun(input);
        if (session !== this.session)
            return;
        if (this.snapshot)
            this.snapshot = { ...this.snapshot, runs: [...this.snapshot.runs.filter(item => item.id !== run.id), run] };
        this.emit();
    }
    async stop(runId) {
        const session = this.session;
        const { run } = await this.api().stopRecruiterMcpRun(runId);
        if (session !== this.session)
            return;
        if (this.snapshot)
            this.snapshot = { ...this.snapshot, runs: this.snapshot.runs.map(item => item.id === run.id ? run : item) };
        this.emit();
    }
}
